<template>
  <v-stepper-step
    :step="step"
    editable
    :edit-icon="icons.success"
    :complete="category.completed"
    :rules="[() => ! category.failed]"
  >
    {{ category.name }}
    <small>{{ __(minKey) }} / {{ __(maxKey) }} {{ category.max | onlyReasonableValues }}</small>
  </v-stepper-step>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    props: {
      index: {
        required: true,
        type: Number,
      },
    },

    computed: {
      step () {
        return this.index + 1
      },
      category () {
        return this.$store.state.orders.modifiers.categories[this.index]
      },
      minKey () {
        return this.category.min === 0 ? 'optional' : 'mandatory'
      },
      maxKey () {
        return this.category.max === 1 ? 'oneOption' : 'multipleOptions'
      },
    },
    filters: {
      onlyReasonableValues: v => v > 1 && v < 100 ? `(${v})` : '',
    },
  }
</script>
